import {
  Modal,
  Row,
  Col,
  DatePicker,
  Radio,
  Select,
  Input,
  Form,
  Skeleton,
  Spin,
  Alert,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import { getFileIcon } from "../fileinformation";
import Editor from "../TextEditor/textEditor";
import "./styles.css";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  editJobOffer,
  fetchChatHistory,
  makeOffer,
  sendMessage_Attachment,
} from "../../redux/actions";
import axios from "axios";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import { fetchToken } from "../../API/API";
import TopAlert from "../TopNotification/TopAlert";

export const OfferModal = ({
  visible,
  setOpenOfferModal,
  bidID,
  editOffer,
  // setDisabled,
  source,
  SkillListingId,
  // stage,
  data,
  hire,
  setOfferLoading
}) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;


  //HOOKS************
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [Message, setMessage] = useState("");
  const [title, setTitle] = useState("Send offer");
  const [attachement, setAttachment] = useState([]);
  const [error, setError] = useState(false);
  const [files, setFiles] = useState([]);
  const [rate, setRate] = useState(0);
  const [fileKey, setFileKey] = useState([]);
  const [currency, setCurrency] = useState("USD");
  const [attachmentError, setAttachmentError] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [msgCounter, setMsgCounter] = useState(0);
  const [uploadFile, setUploadFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const [fileSizeCheck, setFileSizeCheck] = useState(false);
  const [fileTypeCheck, setFileTypeCheck] = useState(false);
  const [docUploadcheck, setDocUploadcheck] = useState(false);
  const [FileName, setFileName] = useState();
  const closeRef = useRef(null);
  const inputFile = useRef(null);
  const profile = useSelector((state) => state.profileReducer.user);

  //Reducers*****
  const loading = useSelector((state) => state.messagesReducer.historyLoading);
  const resp = useSelector((state) => state.messagesReducer.makeOfferRes);
  const professionCode = useSelector(
    (state) => state.profileReducer.user?.profession?.ProfessionCode
  );
  const profession = userProfile?.Professions?.ProfessionCode;
  //set default values when edit
  useEffect(() => {
    if (editOffer) {
      if (editOffer?.Message) {
        setMessage(editOffer?.Message);
      }
      for (let index = 0; index < editOffer?.Attachments?.length; index++) {
        attachement.push({
          file: editOffer?.Attachments[index],
          FileInfo: { FileUrl: editOffer?.Attachments[index].FilePath },
        });
        files.push(editOffer?.Attachments[index]);
        fileKey.push(editOffer?.Attachments[index].FilePath);
      }
      setTitle("Update offer");
    }
  }, [editOffer]);

  //save s3 key and URL
  useEffect(() => {
    if (fileKey?.length == attachement.length) {
      setAttachment(
        attachement.map((res, index) => {
          return {
            ...res,
            FileInfo: {
              FilePath: fileKey[index]?.file,
              FileName: res.file?.FileName ? res.file.FileName : res.file?.name,
              FileSize: res.file?.FileSize ? res.file.FileSize : res.file?.size,
              FileUrl: fileKey[index]?.fileUrl,
            },
          };
        })
      );
    }
  }, [fileKey]);

  useEffect(() => {
    setTimeout(() => {
      setAttachmentError(false);
    }, 3000);
  }, [attachmentError]);

  // useEffect(() => {

  const hireHandler = () => {
    if (hire) {
      dispatch(
        editJobOffer(
          { Status: "Hired", BidType: source == 'Placed'? "Bid" : "Proposals" },
          { id: bidID }
        )
      );
    }
  };

  // }, [resp]);

  //use this array to upload to backend
  useEffect(() => {
    var tempoArr = [];
    for (let index = 0; index < attachement.length; index++) {
      if (attachement.length > 0) {
        tempoArr = [
          ...tempoArr,
          {
            FileName:
              attachement[index]?.file?.FileName ??
              attachement[index].file?.name,
            FilePath:
              attachement[index]?.file?.FilePath ??
              attachement[index]?.FileInfo?.FilePath,
            FileSize:
              attachement[index]?.file?.FileSize ??
              attachement[index].file?.size,
          },
        ];
      }
    }
    setFiles(tempoArr);
  }, [attachement]);

  useEffect(() => {
    if (visible == false) {
      setIsModalVisible(false);
    } else if (visible == true) {
      setIsModalVisible(true);
    }
  }, [visible]);

  const handleOk = () => {
    setIsModalVisible(false);
    setOpenOfferModal(false);
  };

  const handleCancel = () => {
    closeRef.current.resetFields();
    setIsModalVisible(false);
    setOpenOfferModal(false);
  };

  const selectBefore = (
    <Select
      defaultValue="$ USD"
      className="select-before"
      onChange={(e) => setCurrency(e)}
    >
      <Option value="USD">$ USD</Option>
      {/* <Option value="INR">$ INR</Option>
      <Option value="PESO">$ PESO</Option>
      <Option value="CAD">$ CAD</Option> */}
    </Select>
  );

  const onFileChange = async ({ target: { files } }) => {
    setFileSizeCheck(false);
    setFileTypeCheck(false);
 
    if (files.length === 0) {
      return;
    }
 
    const file = files[0];
    const validFileTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/bmp",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ];
 
    if (!validFileTypes.includes(file.type)) {
      setFileTypeCheck(true);
      return;
    }
 
    if (file.size > 10000000) {
      setFileSizeCheck(true);
      return;
    }
 
    setAttachment([...attachement, { file }]);
 
    try {
      const payload = {
        type: "msgAttachment",
        contentType: file.type,
      };
 
      const headers = await fetchToken();
      const getUploadUrl = `${BackendApiBaseUrl}/upload`;
      setUploadFile(true);
 
      const { data } = await axios.post(getUploadUrl, payload, { headers });
 
      if (data?.Key && data?.uploadURL) {
        setFileKey([
          ...fileKey,
          {
            file: data.Key,
            fileUrl: data.uploadURL,
          },
        ]);
 
        await axios.put(data.uploadURL, file);
 
        setUploadFile(false);
        setFileSizeCheck(false);
        setFileTypeCheck(false);
      } else {
        throw new Error("Failed to get upload URL");
      }
    } catch (error) {
      console.error("File upload failed:", error);
      setUploadFile(false);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      if (uploadFile) {
        setUploadFile(false);
      }
      setFileSizeCheck(false);
      setFileTypeCheck(false);
    }, 2200);
  }, [uploadFile, fileSizeCheck, fileTypeCheck]);

  const getFileFormat = (fileName) => {
    const behideDot = fileName?.lastIndexOf(".") + 1;
    const fileLength = fileName?.length;
    const fileFormat = fileName?.slice(behideDot, fileLength);
    return fileFormat;
  };
  async function submitForm(value) {
    setIsModalVisible(false);
    if (!isLoading) {
      setIsLoading(true);
      
    }
    value["onModel"] = source == 'Received' || source == '2'? "proposals" : "bids";
    if (SkillListingId) {
      value["SkillListingId"] = SkillListingId;
    }

    var duration = moment(value["ToDate"]).diff(value["FromDate"], "days");
    if (duration > 30 && duration < 365) {
      var duration = `${moment(value["ToDate"]).diff(
        value["FromDate"],
        "months"
      )} months`;
    } else if (duration > 7 && duration < 30) {
      var duration = `${moment(value["ToDate"]).diff(
        value["FromDate"],
        "weeks"
      )} weeks`;
    } else if (duration < 7) {
      var duration = `${moment(value["ToDate"]).diff(
        value["FromDate"],
        "days"
      )} days`;
    } else if (duration >= 365) {
      var duration = `${moment(value["ToDate"]).diff(
        value["FromDate"],
        "years"
      )}${duration > 365 ? "+ years" : "year"}`;
    }
    if (profession === "HC") {
      value["Rate"] = rate;
    }
   

    value["Currency"] = currency;
    value["Duration"] = duration;
    value["BidType"] = source == 'Received' || source == 2 ? "Proposal" : "Bid";
    value.Message = Message;
    value.Attachments = files;

    value.FromDate = moment.utc(value.FromDate);
    value.ToDate = moment.utc(value.ToDate);
    if (attachement?.length < 1 && profession == "HC") {
      setAttachmentError(true);
    }

    if (attachement?.length > 0 && profession == "HC") {
      setAttachmentError(false);
    }
    if (
      editOffer &&
      (Message != "<p><br></p>" || Message != null)
      // && (!attachement.length < 1 && profession=="HC")
    ) {
      let response = [];
      if (attachement?.length > editOffer?.Attachments?.length) {
        response = (await uploadToBucket(editOffer?.Attachments?.length)) ?? []; //upload file to bucket
      } else {
        response.push("no new file attached");
      }
      let failure = [];
      if (response?.length > 0 && !response.includes("no new file attached")) {
        failure = response?.filter((res) => {
          return res?.status !== 200;
        });
      } else if (attachement?.length > 0 && response?.length === 0) {

        setDocUploadcheck(true);
      }

      if (failure?.length > 0 && attachement?.length > 0) {

        setDocUploadcheck(true);
      }
      if (failure?.length === 0 && response?.length > 0) {

        dispatch(
          editJobOffer(
            { value, loading: "Edit-offer" },
            { id: editOffer?.BidId }
          )
        ); // put request
        setIsModalVisible(false);
        setOpenOfferModal(false);
      }
    } else if (Message != "<p><br></p>" || Message != null) {
      let response = profession == "HC" ? [] : [{ status: 200 }];
      if (attachement.length > 0) {
        response = (await uploadToBucket()) ?? []; //upload file to bucket
      }
      let failure = [];
      if (response?.length > 0) {
        failure = response?.filter((res) => {
          return res?.status !== 200;
        });
      } else if (attachement?.length > 0 && response?.length === 0) {
        setDocUploadcheck(true);
      }

      if (failure?.length > 0 && attachement?.length > 0) {
        setDocUploadcheck(true);
      }
      if (failure?.length === 0 && response?.length > 0) {
        if(hire){
          value["Status"] = "DirectlyHired";
          dispatch(
            editJobOffer(
              { value, loading: "make-offer" },
              { id: bidID }
            )
          );
        }
        else {
          dispatch(makeOffer({ value, loading: "make-offer" }, { id: bidID,successCallBack:(data)=>{
            setOfferLoading(false);
          },
        errorCallBack:(data)=>{

        } }));
          uploadToBucket();
          setOpenOfferModal(false);
      }
      }
    }
    // setDisabled(true);
  }

  async function uploadToBucket(param) {
    const response = [];
    setOfferLoading(true);
    for (let i = param ?? 0; i < attachement.length; i++) {
      try {
        if (attachement[i].FileInfo?.FileUrl) {
          const uploadRequestS3 = await axios.put(
            attachement[i].FileInfo.FileUrl,
            attachement[i].file
          );
          response.push(uploadRequestS3);
        }
      } catch (err) {
        response.push(err);
      }
    }
    return response;
  }

  const onRemoveAttachment = (fileName) => {
    inputFile.current.value = "";
 
    // Remove from attachment list
    const updatedAttachments = attachement.filter((file) => {
      return file.file.name !== fileName && file.file.FileName !== fileName;
    });
    setAttachment(updatedAttachments);
 
    // Find and remove from fileKey
    const updatedFileKeys = fileKey.filter((file) => {
      const fileToRemove = attachement.find(
        (attachment) =>
          attachment.file.name === fileName || attachment.file.FileName === fileName
      );
 
      return file.file !== fileToRemove?.FileInfo?.FilePath;
    });
 
    setFileKey(updatedFileKeys);
  };

  useEffect(() => {
    setTimeout(() => {
      setDocUploadcheck(false);
    }, 8000);
  }, [docUploadcheck]);

  return (
    <div>
      {fileTypeCheck ? (
        <TopAlert
          display={"flex"}
          title={
            "Cannot open this file. The file may be corrupt, or in an unsupported format."
          }
          type="warning"
        />
      ) : null}
      {fileSizeCheck ? (
        <TopAlert
          display={"flex"}
          title={"File size should not exceed 10MB"}
          type="warning"
        />
      ) : null}
      <Modal
        footer={null}
        title="Make an offer"
        centered
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        onClose={handleCancel}
        className="emp-offer-modal"
      >
        <Form
          layout={"vertical"}
          onFinish={submitForm}
          ref={closeRef}
          initialValues={
            editOffer && {
              FromDate: moment(editOffer?.FromDate),
              ToDate: moment(editOffer?.ToDate),
              BudgetType: editOffer.BudgetType,
              Rate: editOffer.Rate,
            }
          }
        >
          {docUploadcheck && (
            <Alert
              message="Error"
              description="Document failed to upload please reload and try again."
              type="error"
              showIcon
              closable
              onClose={() => setDocUploadcheck(false)}
              style={{ marginBottom: "2%" }}
            />
          )}

          <Row className="offer-modal-dates-container">
            <Col lg={11} md={11} className="DatePicker">
              <label className="labels">
                Start date <strong>*</strong>
              </label>
              <Form.Item
                name={"FromDate"}
                style={{ margin: "0%" }}
                rules={[
                  { required: true, message: "Please pick a start date" },
                ]}
              >
                <DatePicker
                  disabledDate={(current) => {
                    return moment().add(-1, "days") >= current;
                  }}
                  onChange={(e) => {
                    setStartDate(e._d);
                  }}
                  format={"MM/DD/YYYY"}
                />
              </Form.Item>
            </Col>

            <Col lg={11} md={11} className="DatePicker">
              <label className="labels">
                End date <strong>*</strong>
              </label>
              <Form.Item
                name="ToDate"
                style={{ margin: "0%" }}
                rules={[{ required: true, message: "Please pick an end date" }]}
              >
                <DatePicker
                  disabledDate={(current) => {
                    return moment(startDate).add(+1, "days") >= current;
                  }}
                  onChange={(e) => {
                    setEndDate(e._d);
                  }}
                  format={"MM/DD/YYYY"}
                />
              </Form.Item>
            </Col>
          </Row>
          {profession === "HC" && (
            <div>
              <label className="labels">
              Estimated pay package <strong style={{ color: "red" }}>*</strong>
              </label>{" "}
              <br />
              <Form.Item
                name={"BudgetType"}
                rules={[{ required: true, message: "Choose a Pay Package" }]}
                style={{ margin: "0% 0% 0% 0%" }}
              >
                <Radio.Group style={{ marginTop: "3%" }}>
                  <Radio value={"Hourly"}>Hourly</Radio>
                  <Radio value={"Weekly"}>Weekly</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                style={{ margin: "0% 0% 3% 0%" }}
                rules={[
                  // { required: true, message: "Year founded is required" },
                  {
                    validator: (_, value) => {
                      if (Number(value) > 0) {
                        return Promise.resolve();
                      } else {
                        if (Number(value) < 0) {
                          return Promise.reject(
                            new Error("Please enter valid rate")
                          );
                        } else {
                          return Promise.reject(
                            new Error("Enter valid desried rate")
                          );
                        }
                      }
                    },
                  },
                ]}
                name={"Rate"}
              >
                <Input
                  addonBefore={selectBefore}
                  addonAfter={null}
                  placeholder="Add Offer Amount..."
                  type={"number"}
                  onChange={(e) => setRate(e.target.value)}
                  className="offer-modal-pckg-input"
                  allowClear
                />
              </Form.Item>
            </div>
          )}
          <div>
            <label className="labels">
              Offer message
              {profession == "HC" && (
                <strong style={{ color: "red" }}>*</strong>
              )}
            </label>
            <Form.Item
              style={{ margin: "0%" }}
              name="Message"
              rules={[
                // { required: true, message: "Year founded is required" },
                {
                  validator: (_, value) => {
                    if (profession == "HC") {
                      if (Message.length > 0 && Message != "<p><br></p>") {
                        setError(false)
                        return Promise.resolve();
                      } else {
                        setError(true)
                        return Promise.reject(
                          new Error("Please Enter the message")
                        );
                        // if (Message.length <= 0) {
                        //   return Promise.reject(
                        //     new Error("Please Enter the message")
                        //   );
                        // } else {
                        //   return Promise.reject(
                        //     new Error("Please Enter the message")
                        //   );
                        // }
                      }
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              { 
                isModalVisible ?
                <Editor
                text={Message}
                error={error}
                setError={setError}
                changeText={(text) => {
                  setMessage(text);
                }}
                counter={(val) => {
                  setMsgCounter(val);
                }}
              /> : null
              }
            </Form.Item>
          </div>
          <div>
            <label className="labels">
              Attach offer
              {profession == "HC" && (
                <strong style={{ color: "red" }}>*</strong>
              )}
            </label>
            <div className="education-message">
                 You can only upload JPEG, JPG, PNG, DOC, PDF formats, and PDF file formats up to 10 MB
            </div>
            <br />
            <Form.Item
              name={"Attachments"}
              style={{ margin: "0%" }}
              rules={[
                // { required: true, message: "Year founded is required" },
                {
                  validator: (_, value) => {
                    if (profession == "HC") {
                      if (attachement.length > 0) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error("Please attach an offer ")
                        );
                        if (value) {
                          return Promise.reject(
                            new Error("Please attach an offer")
                          );
                        } else {
                          return Promise.reject(
                            new Error("Please attach an offer ")
                          );
                        }
                      }
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <div
                className="offer-modal-browse-files"
                // onClick={() => {
                //   inputFile.current.click();
                // }}
              >
                <label className="label" htmlFor="offerFile">
                  Upload offer
                </label>
                <input
                  type="file"
                  id="offerFile"
                  style={{ display: "none" }}
                  ref={inputFile}
                  onChange={(e) => onFileChange(e)}
                />
              </div>
              {attachmentError && (
                <div style={{ color: "red" }}>
                  Please attach an offer document
                </div>
              )}
            </Form.Item>
          </div>
          {uploadFile ? (
            <div style={{ margin: "auto", width: "1%" }}>
              <Spin />
            </div>
          ) : attachement.length > 0 ? (
            attachement.map((res, index) => {
              return (
                <div className="offer-modal-attachments" key={index}>
                  <Row>
                    <img
                      src={getFileIcon(
                        getFileFormat(
                          res.file?.FileName
                            ? res.file?.FileName
                            : res.file?.name
                        )
                      )}
                    />
                    <div style={{ marginLeft: "2%" }}>
                      <AiFillCloseCircle
                        className="remove-attachment-icon"
                        onClick={() =>
                          onRemoveAttachment(
                            res.file?.FileName ?? res.file?.name
                          )
                        }
                      />
                      <div className="fileName-text">
                        {res.file?.FileName
                          ? res.file?.FileName
                          : res.file?.name}
                      </div>{" "}
                      {/* <br /> */}
                      <span>
                        {res.file?.FileSize
                          ? res.file?.FileSize >= 1000000
                            ? Math.round(res.file?.FileSize / 1000000)
                            : Math.round(res.file?.FileSize / 1000)
                          : res.file?.size
                          ? res.file?.size >= 1000000
                            ? Math.round(res.file?.size / 1000000)
                            : Math.round(res.file?.size / 1000)
                          : null}{" "}
                        {res.file?.FileSize >= 1000000 ||
                        res.file?.size >= 1000000
                          ? "MB"
                          : "KB"}{" "}
                        {getFileFormat(res.file?.name)}
                      </span>
                    </div>
                  </Row>
                </div>
              );
            })
          ) : null}
          <Form.Item>
            <div className="offer-modal-button-div">
              <button
                htmltype="submit"
                className={uploadFile ? "btn-disable" : "btn"}
                disabled={uploadFile || isLoading}
              >
                {loading == "make-offer" || loading == "Edit-offer" ? (
                  <LoadingOutlined />
                ) : (
                  title
                )}
              </button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
